import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateTransferUserEmployers = {
  transferUserEmployers: { data: null, loading: false, error: null },
};

export const transferUserEmployers = createAsyncThunk('user/transferUserEmployers', async ({ userId, from_user_id, employers }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/users/${userId}/employers/transfer`,
      { from_user_id, employers },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response?.data || res.response);
    });
});

export const reducerTransferUserEmployers = {
  [transferUserEmployers.pending]: (state) => {
    state.transferUserEmployers.data = null;
    state.transferUserEmployers.loading = true;
    state.transferUserEmployers.error = null;
  },
  [transferUserEmployers.fulfilled]: (state) => {
    state.transferUserEmployers.loading = false;
    state.transferUserEmployers.data = true;
    state.transferUserEmployers.error = null;
  },
  [transferUserEmployers.rejected]: (state, action) => {
    state.transferUserEmployers.data = null;
    state.transferUserEmployers.loading = false;
    state.transferUserEmployers.error = action.payload;
  },
};
